import { render, staticRenderFns } from "./rewardInfo.vue?vue&type=template&id=7f21b95c&scoped=true&"
import script from "./rewardInfo.vue?vue&type=script&lang=js&"
export * from "./rewardInfo.vue?vue&type=script&lang=js&"
import style0 from "./rewardInfo.vue?vue&type=style&index=0&id=7f21b95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21b95c",
  null
  
)

export default component.exports